const configAPI = {
  REACT_APP_API_BASE_URL: window._env_?.REACT_APP_API_BASE_URL,
  REACT_APP_IMAGE_DYNAMIC_URL: window._env_?.REACT_APP_IMAGE_DYNAMIC_URL
};

export default configAPI;
